"use client";

import React from "react";
import SubPageLayout from "@/components/common/SubPageLayout";
import DiagramSection from "@/components/diagrams/DiagramSection";
import DiagramCard from "@/components/diagrams/DiagramCard";
import SinteredLayersDiagram from "@/components/diagrams/SinteredLayersDiagram";
import { useLanguage } from "@/hooks/useLanguage";
import { pick } from "@/lib/i18n";
import { COPY } from "./content";
export default function SinteredMultilayerMeshPage() {
  const {
    lang
  } = useLanguage();
  const content = pick(lang, COPY);
  const diagramCopy = {
    en: {
      sectionTitle: "Diffusion-Bonded Sintered Matrix Architecture",
      sectionLead: "A representative cross-section illustrating protective, filtration control, dispersion, and structural skeleton layers united by solid-state diffusion bonding.",
      cardTitle: "Sintered Laminate Cross-Section Schematic",
      cardDesc: "Process medium moves unidirectionally across diffusion-welded wire intersections, ensuring fixed pore sizing under high load."
    },
    zh: {
      sectionTitle: "多层扩散焊接烧结矩阵立体结构解析",
      sectionLead: "典型截面示意展示表面保护层、核心过滤控制层、均布分流层及底部承重骨架层在高温真空下的原子级熔合结合形态。",
      cardTitle: "烧结复合层间截面与流向示意",
      cardDesc: "工艺介质定向穿透烧结多孔基底，各层接触节点刚性锁定，在交变负荷下杜绝孔隙畸变。"
    },
    es: {
      sectionTitle: "Arquitectura de la matriz sinterizada unida por difusión",
      sectionLead: "Corte transversal representativo que ilustra capas de protección, control de filtración, dispersión y esqueleto estructural unidas por difusión en estado sólido.",
      cardTitle: "Esquema en corte transversal del laminado sinterizado",
      cardDesc: "El fluido avanza de forma unidireccional a través de intersecciones unidas rígidamente, garantizando un tamaño de poro fijo."
    },
    de: {
      sectionTitle: "Diffusionsgebundene Sintermatrix-Architektur",
      sectionLead: "Repräsentativer Querschnitt mit Schutz-, Filtrationskontroll-, Verteilungs- und Strukturskelettlagen, festkörpergebunden im Hochvakuum.",
      cardTitle: "Querschnittsschema des Sinterverbunds",
      cardDesc: "Das Medium durchströmt die metallurgisch verbundenen Drahtkreuzungen gerichtet bei vollständiger Formstabilität."
    },
    fr: {
      sectionTitle: "Architecture de la matrice frittée liée par diffusion",
      sectionLead: "Coupe transversale représentative illustrant les couches de protection, contrôle de filtration, dispersion et ossature porteuse unies par diffusion à l'état solide.",
      cardTitle: "Schéma en coupe du stratifié fritté",
      cardDesc: "Le fluide traverse de façon unidirectionnelle les nœuds soudés, garantissant une ouverture de pore invariable sous charge."
    },
    pt: {
      sectionTitle: "Arquitetura da matriz sinterizada unida por difusão",
      sectionLead: "Corte transversal representativo ilustrando camadas de proteção, controle de filtragem, dispersão e esqueleto estrutural unidas por difusão atômica.",
      cardTitle: "Esquema em corte transversal do laminado sinterizado",
      cardDesc: "O fluxo de processo percorre unidirecionalmente as interseções fundidas, assegurando geometria de retenção inalterável."
    }
  };
  const d = pick(lang, diagramCopy);
  const diagram = <DiagramSection id="sintered-multilayer-diagram" title={d.sectionTitle} lead={d.sectionLead} tone="background">
      <div className="max-w-3xl mx-auto">
        <DiagramCard index="SWM-MULTI" badge="Diffusion Bonded Matrix" title={d.cardTitle} description={d.cardDesc}>
          <SinteredLayersDiagram variant="overview" />
        </DiagramCard>
      </div>
    </DiagramSection>;
  return <SubPageLayout content={content} diagram={diagram} />;
}